import React, { useEffect } from "react";

export default function OracleToast({ toast, onClose }) {
  useEffect(() => {
    if (!toast) return;
    const t = setTimeout(() => onClose && onClose(), toast.duration || 3800);
    return () => clearTimeout(t);
  }, [toast, onClose]);

  if (!toast) return null;
  const kind = toast.kind || "info";
  return (
    <div
      className={`oracle-toast oracle-toast--${kind}`}
      role="status"
      aria-live="polite"
      data-testid="oracle-toast"
    >
      <div className="oracle-toast__icon" aria-hidden="true">
        {kind === "success" ? "✨" : kind === "error" ? "⚠️" : kind === "warn" ? "🟡" : "🔮"}
      </div>
      <div className="oracle-toast__txt">
        {toast.title && <div className="oracle-toast__title">{toast.title}</div>}
        <div className="oracle-toast__msg">{toast.message}</div>
      </div>
      <button
        type="button"
        className="oracle-toast__close"
        onClick={() => onClose && onClose()}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
}
